// import { useState } from "react";

// const JobApplyModal = ({ isOpen, onClose, job, onApply, company }) => {
//   const [resumeLink, setResumeLink] = useState(""); // Changed from file input
//   const [coverLetter, setCoverLetter] = useState("");
//   const [linkedinProfile, setLinkedinProfile] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   if (!isOpen || !job) return null;

//   const handleSubmit = async () => {
//     if (!resumeLink) {
//       setError("Please provide a resume link.");
//       return;
//     }

//     setLoading(true);
//     setError("");

//     const applicationData = {
//       resume: resumeLink, // Now sending the link instead of a file
//       coverLetter,
//       linkedinProfile,
//     };

//     await onApply(applicationData); // Calls apply function from JobCard

//     setLoading(false);
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//       <div className="bg-white p-6 rounded-lg w-11/12 max-w-[45rem] shadow-lg max-h-[90vh] overflow-y-auto">
//         {/* Header */}
//         <div className="flex justify-between items-center border-b pb-2 mb-4">
//           <h2 className="text-xl font-semibold">
//             {job.jobTitle} at {company.name}
//           </h2>
//           <button onClick={onClose} className="text-gray-600 hover:text-gray-900 text-2xl">
//             ✖
//           </button>
//         </div>

//         {/* Job Details */}
//         <div className="space-y-2 text-gray-700">
//           <p><strong>📍 Location:</strong> {job.location || "Not specified"}</p>
//           <p><strong>🛠 Job Type:</strong> {job.jobType || "Not specified"}</p>
//           <p><strong>⏳ Duration:</strong> {job.duration || "Not specified"}</p>
//           <p><strong>💰 Salary/Stipend:</strong> {job.salary ? `${job.salary}` : "Not specified"}</p>
//           <p><strong>🎯 Openings:</strong> {job.openings ? `${job.openings} positions` : "Not specified"}</p>

//           <p><strong>📅 Start Date:</strong> {job.postedAt?.seconds ? new Date(job.postedAt.seconds * 1000).toLocaleDateString() : "Not specified"}</p>
//           <p><strong>🚨 Deadline:</strong> {job.applicationDeadline}</p>

//           <p><strong>🔹 Skills Required:</strong> {Array.isArray(job.skillsRequired) && job.skillsRequired.length > 0 ? job.skillsRequired.join(", ") : "Not specified"}</p>
//           <p><strong>🎁 Company Size:</strong> {company.size}</p>

//           {/* About Company */}
//           <div className="mt-2 bg-gray-100 p-3 rounded-md">
//             <p className="font-semibold">🏢 About {company.name}:</p>
//             <p className="text-sm">{company.description}</p>
//           </div>

//           {/* Job Description */}
//           <div className="mt-2 bg-gray-50 p-3 rounded-md">
//             <p className="font-semibold">📝 Job Description:</p>
//             <p className="text-sm">{job.jobDescription}</p>
//           </div>
//         </div>

//         {/* Application Form */}
//         <div className="mt-4">
//           <label className="block text-gray-600 font-semibold mb-1">📄 Resume Link</label>
//           <input
//             type="text"
//             className="w-full border p-2 rounded bg-white"
//             placeholder="Paste your resume link here"
//             value={resumeLink}
//             onChange={(e) => setResumeLink(e.target.value)}
//           />

//           <label className="block text-gray-600 font-semibold mt-3 mb-1">✉ Cover Letter</label>
//           <textarea
//             className="w-full border p-2 rounded"
//             placeholder="Write your cover letter here (max 100 words)..."
//             value={coverLetter}
//             onChange={(e) => {
//               const words = e.target.value.trim() === "" ? [] : e.target.value.trim().split(/\s+/);
//               if (words.length <= 100) {
//                 setCoverLetter(e.target.value);
//               }
//             }}
//           ></textarea>
//           <p className="text-sm text-gray-500 mt-1">
//             {coverLetter.trim() === "" ? 0 : coverLetter.trim().split(/\s+/).length} / 100 words
//           </p>


//           <label className="block text-gray-600 font-semibold mt-3 mb-1">🔗 LinkedIn Profile</label>
//           <input
//             type="text"
//             className="w-full border p-2 rounded"
//             placeholder="Enter your LinkedIn URL"
//             value={linkedinProfile}
//             onChange={(e) => setLinkedinProfile(e.target.value)}
//           />
//         </div>

//         {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

//         {/* Apply Button */}
//         <button
//           onClick={handleSubmit}
//           className={`mt-4 w-full py-2 rounded font-semibold transition-all ${loading ? "bg-gray-400 text-gray-800 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700"
//             }`}
//           disabled={loading}
//         >
//           {loading ? "Applying..." : "🚀 Apply Now"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default JobApplyModal;


import { useState } from "react";
import { FiArrowLeft, FiArrowRight, FiLinkedin, FiTwitter, FiGlobe, FiGithub, FiFacebook } from "react-icons/fi";
import { FaLinkedinIn, FaTwitter, FaFacebookF, FaGlobe } from "react-icons/fa";

const JobApplyModal = ({ isOpen, onClose, job, onApply, company }) => {
  const [resumeLink, setResumeLink] = useState("");
  const [coverLetter, setCoverLetter] = useState("");
  const [linkedinProfile, setLinkedinProfile] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [coverLetterPage, setCoverLetterPage] = useState(0);
  const [isGeneratingCoverLetter, setIsGeneratingCoverLetter] = useState(false);

  if (!isOpen || !job) return null;

  // Format job description with markdown-like syntax
  const formatJobDescription = (text) => {
    if (!text) return "";
    
    // Handle **bold** text as subheadings
    let formattedText = text.replace(/\*\*(.*?)\*\*/g, '<h3 class="font-bold text-lg mt-4 mb-2">$1</h3>');
    
    // Handle * bullet points
    formattedText = formattedText.replace(/\*(.*?)(\n|$)/g, '<li class="ml-4 list-disc">$1</li>');
    
    // Replace newlines with breaks
    formattedText = formattedText.replace(/\n/g, '<br />');
    
    return { __html: formattedText };
  };

  // Generate cover letter using job description
  const generateCoverLetter = async () => {
    if (!job.jobTitle || !company.name) {
      setError("Job information is incomplete");
      return;
    }
    
    setIsGeneratingCoverLetter(true);
    setError("");
    
    try {
      // Simulate API call (replace with actual API call)
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Generate a template cover letter based on job details
      const generatedLetter = `Dear Hiring Manager at ${company.name},\n\n` +
        `I am excited to apply for the ${job.jobTitle} position. ` +
        `With my skills in ${job.skillsRequired?.slice(0, 3).join(', ') || 'relevant technologies'}, ` +
        `I believe I would be a great fit for your team.\n\n` +
        `**Why I'm a great fit**\n` +
        `* Strong experience in key required areas\n` +
        `* Proven track record of success\n` +
        `* Passion for ${job.department || 'this field'}\n\n` +
        `I look forward to the opportunity to contribute to ${company.name}'s success. ` +
        `Please find my resume attached for your review.\n\n` +
        `Best regards,\n[Your Name]`;
      
      setCoverLetter(generatedLetter);
    } catch (err) {
      setError("Failed to generate cover letter. Please try again.");
    } finally {
      setIsGeneratingCoverLetter(false);
    }
  };

  // Split cover letter into pages for better readability
  const splitCoverLetter = (text) => {
    if (!text) return [""];
    const words = text.split(/\s+/);
    const pages = [];
    let currentPage = [];
    let wordCount = 0;
    
    words.forEach(word => {
      if (wordCount + 1 <= 100) {
        currentPage.push(word);
        wordCount++;
      } else {
        pages.push(currentPage.join(' '));
        currentPage = [word];
        wordCount = 1;
      }
    });
    
    if (currentPage.length > 0) {
      pages.push(currentPage.join(' '));
    }
    
    return pages;
  };

  const coverLetterPages = splitCoverLetter(coverLetter);
  const currentPageText = coverLetterPages[coverLetterPage] || "";

  const handleSubmit = async () => {
    if (!resumeLink) {
      setError("Please provide a resume link.");
      return;
    }

    setLoading(true);
    setError("");

    const applicationData = {
      resume: resumeLink,
      coverLetter,
      linkedinProfile,
    };

    await onApply(applicationData);

    setLoading(false);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg w-11/12 max-w-[45rem] shadow-lg max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-2 mb-4">
          <h2 className="text-xl font-semibold">
            {job.jobTitle} at {company.name}
          </h2>
          <button onClick={onClose} className="text-gray-600 hover:text-gray-900 text-2xl">
            ✖
          </button>
        </div>

        {/* Job Details */}
        <div className="space-y-2 text-gray-700">
          <p><strong>📍 Location:</strong> {job.location || "Not specified"}</p>
          <p><strong>🛠 Job Type:</strong> {job.jobType || "Not specified"}</p>
          <p><strong>⏳ Duration:</strong> {job.duration || "Not specified"}</p>
          <p><strong>💰 Salary/Stipend:</strong> {job.salary ? `${job.salary}` : "Not specified"}</p>
          <p><strong>🎯 Openings:</strong> {job.openings ? `${job.openings} positions` : "Not specified"}</p>
          <p><strong>📅 Start Date:</strong> {job.postedAt?.seconds ? new Date(job.postedAt.seconds * 1000).toLocaleDateString() : "Not specified"}</p>
          <p><strong>🚨 Deadline:</strong> {job.applicationDeadline}</p>
          <p><strong>🔹 Skills Required:</strong> {Array.isArray(job.skillsRequired) && job.skillsRequired.length > 0 ? job.skillsRequired.join(", ") : "Not specified"}</p>
          <p><strong>🎁 Company Size:</strong> {company.size}</p>

          {/* About Company - Responsive */}
          <div className="mt-4 bg-gray-100 p-4 rounded-md">
            <div className="flex flex-col">
              <div className="mb-3">
                <p className="font-semibold text-lg">🏢 About {company.name}</p>
                <p className="text-sm mt-1">{company.description}</p>
              </div>
              
              {/* Company Social Links */}
              {(company.socialLinks?.linkedin || company.socialLinks?.twitter || company.socialLinks?.website || company.socialLinks?.facebook) && (
                <div className="flex flex-wrap gap-4 mt-2">
                  {company.socialLinks?.website && (
                    <a href={company.socialLinks.website} target="_blank" rel="noopener noreferrer" 
                      className="text-gray-700 hover:text-blue-600 transition-colors flex items-center gap-1 text-sm">
                      <FaGlobe size={14} /> Website
                    </a>
                  )}
                  {company.socialLinks?.linkedin && (
                    <a href={company.socialLinks.linkedin} target="_blank" rel="noopener noreferrer" 
                      className="text-gray-700 hover:text-blue-700 transition-colors flex items-center gap-1 text-sm">
                      <FaLinkedinIn size={14} /> LinkedIn
                    </a>
                  )}
                  {company.socialLinks?.twitter && (
                    <a href={company.socialLinks.twitter} target="_blank" rel="noopener noreferrer" 
                      className="text-gray-700 hover:text-blue-400 transition-colors flex items-center gap-1 text-sm">
                      <FaTwitter size={14} /> Twitter
                    </a>
                  )}
                  {company.socialLinks?.facebook && (
                    <a href={company.socialLinks.facebook} target="_blank" rel="noopener noreferrer" 
                      className="text-gray-700 hover:text-blue-600 transition-colors flex items-center gap-1 text-sm">
                      <FaFacebookF size={14} /> Facebook
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Job Description with formatting */}
          <div className="mt-4 bg-gray-50 p-4 rounded-md">
            <p className="font-semibold text-lg mb-2">📝 Job Description</p>
            <div 
              className="text-sm job-description-content"
              dangerouslySetInnerHTML={formatJobDescription(job.jobDescription)}
            />
          </div>
        </div>

        {/* Application Form */}
        <div className="mt-6">
          <label className="block text-gray-600 font-semibold mb-1">📄 Resume Link</label>
          <input
            type="text"
            className="w-full border p-2 rounded bg-white"
            placeholder="Paste your resume link (Google Drive, Dropbox, etc.)"
            value={resumeLink}
            onChange={(e) => setResumeLink(e.target.value)}
          />

          <div className="mt-4">
            <div className="flex justify-between items-center mb-1">
              <label className="block text-gray-600 font-semibold">✉ Cover Letter</label>
              <button
                onClick={generateCoverLetter}
                disabled={isGeneratingCoverLetter}
                className="text-sm bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded flex items-center"
              >
                {isGeneratingCoverLetter ? (
                  <>
                    <span className="animate-pulse">Generating...</span>
                  </>
                ) : (
                  "✨ Generate"
                )}
              </button>
            </div>

            {/* Cover Letter Pager */}
            {coverLetterPages.length > 1 && (
              <div className="flex justify-between items-center mb-2">
                <button
                  onClick={() => setCoverLetterPage(p => Math.max(0, p - 1))}
                  disabled={coverLetterPage === 0}
                  className="p-1 rounded-full hover:bg-gray-100 disabled:opacity-50"
                >
                  <FiArrowLeft size={18} />
                </button>
                <span className="text-sm text-gray-500">
                  Page {coverLetterPage + 1} of {coverLetterPages.length}
                </span>
                <button
                  onClick={() => setCoverLetterPage(p => Math.min(coverLetterPages.length - 1, p + 1))}
                  disabled={coverLetterPage === coverLetterPages.length - 1}
                  className="p-1 rounded-full hover:bg-gray-100 disabled:opacity-50"
                >
                  <FiArrowRight size={18} />
                </button>
              </div>
            )}

            <textarea
              className="w-full border p-3 rounded min-h-[150px]"
              placeholder="Write your cover letter here (max 100 words per page)..."
              value={currentPageText}
              onChange={(e) => {
                const words = e.target.value.trim() === "" ? [] : e.target.value.trim().split(/\s+/);
                if (words.length <= 100) {
                  const newPages = [...coverLetterPages];
                  newPages[coverLetterPage] = e.target.value;
                  setCoverLetter(newPages.join(' '));
                }
              }}
            ></textarea>
            <div className="flex justify-between items-center mt-1">
              <p className="text-sm text-gray-500">
                {currentPageText.trim() === "" ? 0 : currentPageText.trim().split(/\s+/).length} / 100 words
              </p>
              {coverLetterPages.length > 1 && (
                <p className="text-xs text-gray-500">
                  Tip: Use arrows to navigate between pages
                </p>
              )}
            </div>
          </div>

          <label className="block text-gray-600 font-semibold mt-4 mb-1">🔗 LinkedIn Profile</label>
          <input
            type="text"
            className="w-full border p-2 rounded"
            placeholder="https://linkedin.com/in/your-profile"
            value={linkedinProfile}
            onChange={(e) => setLinkedinProfile(e.target.value)}
          />
        </div>

        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

        {/* Apply Button */}
        <button
          onClick={handleSubmit}
          className={`mt-6 w-full py-3 rounded-lg font-semibold transition-all ${loading ? "bg-gray-400 text-gray-800 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          disabled={loading}
        >
          {loading ? (
            <span className="flex items-center justify-center">
              <span className="animate-spin mr-2">🌀</span> Applying...
            </span>
          ) : (
            "🚀 Apply Now"
          )}
        </button>
      </div>
    </div>
  );
};

export default JobApplyModal;